import React, { useState, useEffect } from "react";
import { FaSearch, FaBars, FaTimes, FaUserCircle } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../Images/CompanyLogo.png";
import "./Navbar.scss";

const Navbar = () => {
  const [isSearchExpanded, setIsSearchExpanded] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredRoutes, setFilteredRoutes] = useState([]);
  const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);
  const [username, setUsername] = useState(""); // State to store username
  const navigate = useNavigate();

  const routes = [
    { id: 1, path: "/home/dashboard", label: "Dashboard" },
    { id: 2, path: "/home/software-update/modules", label: "Modules" },
    { id: 3, path: "/home/software-update/plans", label: "Plans" },
    { id: 4, path: "/home/software-update/pricing", label: "Pricing" },
    { id: 5, path: "/home/software-update", label: "Software Update" },
    { id: 6, path: "/home/tenant-manager", label: "Tenant Manager" },
  ];

  useEffect(() => {
    const storedUsername = sessionStorage.getItem("username");
    if (storedUsername) {
      setUsername(storedUsername); // Set username if exists in sessionStorage
    }
  }, []);

  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    if (query) {
      const filtered = routes.filter((route) =>
        route.label.toLowerCase().includes(query.toLowerCase())
      );
      setFilteredRoutes(filtered);
    } else {
      setFilteredRoutes([]);
    }
  };

  const handleSearchClick = (path) => {
    navigate(path);
    setSearchQuery("");
    setFilteredRoutes([]);
    setIsSearchExpanded(false);
  };

  const toggleSearch = () => {
    setIsSearchExpanded(!isSearchExpanded);
    if (!isSearchExpanded) {
      setSearchQuery("");
      setFilteredRoutes([]);
    }
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const toggleProfileDropdown = () => {
    setIsProfileDropdownOpen(!isProfileDropdownOpen);
  };

  const handleLogout = () => {
    sessionStorage.clear();
    localStorage.removeItem("selectedProduct");

    const cookiesToClear = ["Refresh_Token"];
    cookiesToClear.forEach((cookieName) => {
      document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Strict`;
    });

    navigate("/login");
  };

  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <Link to="/">
          <img src={logo} alt="Logo" />
        </Link>
      </div>
      <div className={`navbar-menu ${isMenuOpen ? "open" : ""}`}>
        <div className="navbar-close" onClick={closeMenu}>
          <FaTimes />
        </div>
        <div
          className={`search-container ${isSearchExpanded ? "expanded" : ""}`}
        >
          <input
            type="text"
            className="search-input"
            placeholder="Search for Modules, Plans, Pricing..."
            value={searchQuery}
            onChange={handleSearchChange}
            onFocus={() => setIsSearchExpanded(true)}
          />
          <FaSearch className="search-icon" onClick={toggleSearch} />
          {isSearchExpanded && filteredRoutes.length > 0 && (
            <div className="search-popup">
              {filteredRoutes.map((route) => (
                <div
                  key={route.id}
                  className="search-result"
                  onMouseDown={() => handleSearchClick(route.path)}
                >
                  {route.label}
                </div>
              ))}
            </div>
          )}
        </div>
        <div
          className={`profile-icon-container ${
            isProfileDropdownOpen ? "open" : ""
          }`}
        >
          <div className="profile-icon" onClick={toggleProfileDropdown}>
            <FaUserCircle />
          </div>
          {isProfileDropdownOpen && (
            <div className="profile-dropdown">
              <div className="dropdown-item">
                <strong>{username || "User"}</strong>
              </div>
              <div className="dropdown-divider"></div>
              <div className="dropdown-logout" onClick={handleLogout}>
                Logout
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="navbar-toggle" onClick={toggleMenu}>
        {isMenuOpen ? <FaTimes /> : <FaBars />}
      </div>
    </nav>
  );
};

export default Navbar;
